export const REQUEST_RESCHEDULESLOT = 'REQUEST_RESCHEDULESLOT';
export const RESCHEDULESLOT_RECEIVED = 'RESCHEDULESLOT_RECEIVED';
export const CLEAR_RESCHEDULESLOT = 'CLEAR_RESCHEDULESLOT';
